import { render, staticRenderFns } from "./Modern.vue?vue&type=template&id=1b14393b"
import script from "./Modern.vue?vue&type=script&lang=js"
export * from "./Modern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports